export default {
    state: {
        component: '',
        drawer: false,
    },
    mutations: {
        OPEN_POPUP: (state, component) => {
            state.component = component
        },
        CLOSE_POPUP: (state) => {
            state.component = ''
        },
        SET_DRAWER: (state, flag) => {
            state.drawer = flag
        },
        TOGGLE_DRAWER: (state) => {
            state.drawer = !state.drawer
        },
    },
}